module.exports = __webpack_public_path__ + "static/media/boton1.0e8ce9ce.svg";